module.exports = __webpack_public_path__ + "static/social_newsletter-d71ffe572041d0f5007f8ff630e668d8.png";